import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'redux-little-router';
import classnames from 'classnames';
import { get } from 'lodash';

import Warning from '../../../../components/Warning/index';
import Loading from '../../../../components/Loading/index';
import { routeMap } from '../../../../router';
import AccountsAbroadListFiltersContainer from '../../containers/AccountsAbroadListFiltersContainer';

export default class AccountsAbroad extends Component {
  static propTypes = {
    config: PropTypes.shape({
      isInspectorArm: PropTypes.bool.isRequired,
    }).isRequired,
    accountsAbroad: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          accountContractDate: PropTypes.object,
          accountContractNumber: PropTypes.string,
          accountNumber: PropTypes.string,
          accountNumberChangeDate: PropTypes.object,
          accountNumberChanged: PropTypes.bool,
          accountType: PropTypes.string,
          accountTypeCode: PropTypes.number.isRequired,
          bankAccountTypeId: PropTypes.string,
          bankAddress: PropTypes.string,
          bankBic: PropTypes.string,
          bankDataUpdateDate: PropTypes.object,
          bankDataUpdated: PropTypes.bool,
          bankName: PropTypes.string,
          closeDate: PropTypes.object,
          closeNotificationDate: PropTypes.object,
          closed: PropTypes.bool,
          coownersNumber: PropTypes.number,
          countryCode: PropTypes.string,
          countryId: PropTypes.number,
          countryName: PropTypes.string.isRequired,
          countryShortName: PropTypes.string.isRequired,
          openDate: PropTypes.object,
          openNotificationDate: PropTypes.object,
          pseudonym: PropTypes.string,
          recordCreateDate: PropTypes.object,
          recordUpdateDate: PropTypes.object,
          permissionDate: PropTypes.object,
          permission: PropTypes.string,
          taxpayerId: PropTypes.number.isRequired,
          updateNotificationDate: PropTypes.object,
        }),
      ),
      error: PropTypes.string,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
    accountsAbroadListFilters: PropTypes.shape({
      accountStatus: PropTypes.shape({
        filterFn: PropTypes.func,
        label: PropTypes.string,
        value: PropTypes.number,
      }),
      bank: PropTypes.shape({
        filterFn: PropTypes.func,
        label: PropTypes.string,
        value: PropTypes.number,
      }),
    }).isRequired,
    loadAccountsAbroad: PropTypes.func,
  };

  componentDidMount() {
    this.props.loadAccountsAbroad();
  }

  getData() {
    const { accountsAbroad, accountsAbroadListFilters } = this.props;
    const accounts = get(accountsAbroad, 'data');
    const bankFilter = get(accountsAbroadListFilters, 'bank').filterFn;
    const accountStatusFilter = get(accountsAbroadListFilters, 'accountStatus').filterFn;

    return accounts.filter((account) => bankFilter(account) && accountStatusFilter(account));
  }

  getAccountLink(route, accountId) {
    return {
      pathname: route,
      query: { accountId },
    };
  }

  renderLoading = () => {
    return (
      <div className="loading-container loading-container__middle">
        <Loading />
      </div>
    );
  };

  renderActionLinksCell = (account) => {
    if (this.props.config.isInspectorArm) {
      return null;
    }

    return (
      <td>
        <div className="table_name grey">Действия</div>
        <div className="table_param">
          {!account.closed ? (
            <div>
              <div className="page_margin10">
                <Link
                  href={this.getAccountLink(routeMap.changeAccountProps, account.bankAccountId)}
                >
                  Уведомить об изменении реквизитов счета
                </Link>
              </div>
              <div className="page_margin10">
                <Link
                  href={this.getAccountLink(
                    routeMap.closingForeignBankAccount,
                    account.bankAccountId,
                  )}
                >
                  Уведомить о закрытии счета
                </Link>
              </div>
            </div>
          ) : null}
          <div>
            <Link href={this.getAccountLink(routeMap.movementReportForm, account.bankAccountId)}>
              Отправить отчет о движении средств по счету
            </Link>
          </div>
        </div>
      </td>
    );
  };

  renderAccountsTable = () => {
    const accounts = this.getData();
    let accountsCounter = 1;

    return (
      <table className="table">
        <thead>
          <tr>
            <th>Наименование счета</th>
            <th>Наименование банка</th>
            <th>Номер счета</th>
            {!this.props.config.isInspectorArm ? <th>Действия</th> : null}
          </tr>
        </thead>
        <tbody>
          {accounts.map((account, key) => {
            const rowClassNames = classnames({ table_disabled: account.closed });
            let pseudonym = account.pseudonym;
            if (!account.pseudonym) {
              pseudonym = `Счет ${accountsCounter}`;
              accountsCounter++;
            }
            return (
              <tr key={key} className={rowClassNames}>
                <td className="table_20">
                  <div className="table_name grey">Вид налога</div>
                  <div className="table_param first-letter-uppercase">
                    <Link
                      href={this.getAccountLink(
                        routeMap.profileAccountDetails,
                        account.bankAccountId,
                      )}
                    >
                      {pseudonym}
                    </Link>
                  </div>
                </td>
                <td className="table_20">
                  <div className="table_name grey">Наименование банка</div>
                  <div className="table_param first-letter-uppercase">{account.bankName}</div>
                </td>
                <td className="table_fix150">
                  <div className="table_name grey">Номер счета</div>
                  <div className="table_param">
                    {/* todo: add link to account page */}
                    {account.accountNumber}
                  </div>
                </td>
                {this.renderActionLinksCell(account)}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  renderAccountsData = () => {
    const { accountsAbroad } = this.props;
    const isLoading = get(accountsAbroad, 'loading') || !get(accountsAbroad, 'data');
    const hasError = get(accountsAbroad, 'error');

    if (hasError) {
      return <Warning />;
    }

    if (isLoading) {
      return this.renderLoading();
    }

    const accounts = get(accountsAbroad, 'data');
    if (!accounts.length) {
      return null;
    }

    return (
      <div>
        <AccountsAbroadListFiltersContainer accounts={accounts} />
        {this.renderAccountsTable()}
      </div>
    );
  };

  render() {
    return (
      <div className={'white-block__pad40 pt-0'}>
        <p className="page_margin20">
          На данной странице представлены счета в зарубежных банках, которые Вы сохранили.
          <br />
          Вы можете использовать сохраненные реквизиты для подачи уведомлений и отчетов по счетам.
        </p>
        {!this.props.config.isInspectorArm ? (
          <p className="page_margin20">
            <Link href={routeMap.openingForeignBankAccount}>
              Уведомить об открытии нового счета
            </Link>
          </p>
        ) : null}
        {this.renderAccountsData()}
      </div>
    );
  }
}
